module.exports = __webpack_public_path__ + "static/media/6H.13bea5a1.svg";